import ToolTip from "./ToolTip";
import {ToolTipPosition, ToolTipContent} from "./ToolTip";
export default ToolTip;
export {ToolTipPosition, ToolTipContent};